<template>
    <modal id="candidate-modal"
        size="large"
        v-model="showModal"
        :title="generateModalTitle('candidate')"
        @submit="submitData" :loading="loading"
        :preloader="preloader">

        <form
            ref="form"
            :data-url='selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/candidate`'
            @submit.prevent="submitData"
        >
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="candidate-avatar">{{ $t('avatar') }}</label>
                        <app-input
                            id="candidate-avatar"
                            type="custom-file-upload"
                            :generate-file-url="false"
                            v-model="formData.avatar"
                            :label="$t('change_image')"
                            :error-message="$errorMessage(errors, 'avatar')"
                        />
                    </div>
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('work_place')"
                        list-value-field="title"
                        v-model="formData.work_place_id"
                        :required="true"
                        :chooseLabel="$t('work_place')"
                        :error-message="$errorMessage(errors, 'work_place_id')"
                        :fetch-url="`${TENANT_BASE_URL}api/work-place?per_page=0&locate=${locate}`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('name_romaji')"
                        type="text"
                        :placeholder="$placeholder('name_romaji', '')"
                        v-model="formData.name_romaji"
                        :error-message="$errorMessage(errors, 'name_romaji')"
                        :required="true"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('name_katakana')"
                        type="text"
                        :placeholder="$placeholder('name_katakana', '')"
                        v-model="formData.name_katakana"
                        :error-message="$errorMessage(errors, 'name_katakana')"
                        :required="true"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('email')"
                        type="email"
                        :placeholder="$placeholder('email', '')"
                        v-model="formData.email"
                        :error-message="$errorMessage(errors, 'email')"
                        :required="true"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$fieldTitle('contact', 'number')"
                        type="tel-input"
                        id="input-text-contact"
                        :placeholder="formData.phone ? $placeholder('contact', 'number') : this.$t('not_added_yet')"
                        v-model="formData.phone"
                        :error-message="$errorMessage(errors, 'phone')"
                        :required="true"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('gender')"
                        type="select"
                        :list="[
                            {id:'male',value: $t('male')},
                            {id:'female', value:  $t('female')},
                            {id:'other', value:  $t('other')}
                        ]"
                        v-model="formData.gender"
                        :error-message="$errorMessage(errors, 'gender')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('residence')"
                        list-value-field="name"
                        v-model="formData.residence"
                        :required="true"
                        :chooseLabel="$t('residence')"
                        :error-message="$errorMessage(errors, 'residence')"
                        :fetch-url="`${TENANT_BASE_URL}api/candidate/residence`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('clothing_size')"
                        list-value-field="name"
                        v-model="formData.clothing_size"
                        :required="true"
                        :chooseLabel="$t('clothing_size')"
                        :error-message="$errorMessage(errors, 'clothing_size')"
                        :fetch-url="`${TENANT_BASE_URL}api/candidate/size`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="select"
                        :label="$t('experience')"
                        list-value-field="name"
                        v-model="formData.experience"
                        :required="true"
                        :chooseLabel="$t('experience')"
                        :error-message="$errorMessage(errors, 'experience')"
                        radio-checkbox-name="0"
                        :list="[
                            { id: 0, name: $t('no_experience') },
                            { id: 1, name: $t('yes_experience') },
                        ]"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="select"
                        :label="$t('years_in_japan')"
                        list-value-field="name"
                        v-model="formData.in_japan"
                        :required="true"
                        :chooseLabel="$t('years_in_japan')"
                        :error-message="$errorMessage(errors, 'in_japan')"
                        :list="[
                            { id: 1, name: 1 },
                            { id: 2, name: 2 },
                            { id: 3, name: 3 },
                            { id: 4, name: 4 },
                            { id: 5, name: 5 },
                            { id: 6, name: 6 },
                            { id: 7, name: 7 },
                            { id: 8, name: 8 },
                            { id: 9, name: 9 },
                            { id: 10, name: 10 },
                        ]"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('start_date')"
                        v-model="formData.start"
                        :placeholder="formData.start ? $placeholder('start_date') : this.$t('not_added_yet')"
                        :error-message="$errorMessage(errors, 'start')"
                        :required="true"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('station')"
                        type="text"
                        :placeholder="$placeholder('station', '')"
                        v-model="formData.station"
                        :error-message="$errorMessage(errors, 'station')"
                        :required="true"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('commuting_time')"
                        type="number"
                        :placeholder="$placeholder('commuting_time', '')"
                        v-model="formData.how_long"
                        :error-message="$errorMessage(errors, 'how_long')"
                        :required="true"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('job_broker')"
                        type="text"
                        :placeholder="$placeholder('job_broker', '')"
                        v-model="formData.job_broker"
                        :read-only="isEditMode"
                        :error-message="$errorMessage(errors, 'job_broker')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('fb_link')"
                        type="text"
                        :placeholder="$placeholder('fb_link', '')"
                        v-model="formData.fb_link"
                        :error-message="$errorMessage(errors, 'fb_link')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="select"
                        :label="$t('recruitment')"
                        list-value-field="name"
                        v-model="formData.recruitment"
                        :required="true"
                        :chooseLabel="$t('recruitment')"
                        :error-message="$errorMessage(errors, 'recruitment')"
                        :list="[
                            { id: 1, name: $t('applied') },
                            { id: 2, name: $t('interviewed') },
                            { id: 3, name: $t('rejected') },
                            { id: 4, name: $t('accepted') },
                            { id: 5, name: $t('awaiting_visa') },
                            { id: 6, name: $t('started') },
                        ]"
                    />
                </div>

                <template v-for="field in fields" v-if="fields.length > 0">
                    <div class="col-md-6">
                        <app-form-group
                            :label="field.label[locate] || field.label['ja']"
                            :type="field.type"
                            :list="field.options"
                            :error-message="$errorMessage(errors, field.name)"
                            :file-label="$placeholder('attachment', '')"
                            v-model="formData[field.name]"
                        />
                    </div>
                </template>

                <div class="col-md-12 m-0"></div>

                <div class="col-md-4">
                    <app-form-group
                        type="select"
                        :label="$t('monday')"
                        list-value-field="name"
                        v-model="formData.monday"
                        :required="true"
                        :chooseLabel="$t('time')"
                        :error-message="$errorMessage(errors, 'monday')"
                        :list="timeList"
                    />
                </div>
                <div class="col-md-4">
                    <app-form-group
                        type="select"
                        :label="$t('tuesday')"
                        list-value-field="name"
                        v-model="formData.tuesday"
                        :required="true"
                        :chooseLabel="$t('time')"
                        :error-message="$errorMessage(errors, 'tuesday')"
                        :list="timeList"
                    />
                </div>
                <div class="col-md-4">
                    <app-form-group
                        type="select"
                        :label="$t('wednesday')"
                        list-value-field="name"
                        v-model="formData.wednesday"
                        :required="true"
                        :chooseLabel="$t('time')"
                        :error-message="$errorMessage(errors, 'wednesday')"
                        :list="timeList"
                    />
                </div>
                <div class="col-md-4">
                    <app-form-group
                        type="select"
                        :label="$t('thursday')"
                        list-value-field="name"
                        v-model="formData.thursday"
                        :required="true"
                        :chooseLabel="$t('time')"
                        :error-message="$errorMessage(errors, 'thursday')"
                        :list="timeList"
                    />
                </div>
                <div class="col-md-4">
                    <app-form-group
                        type="select"
                        :label="$t('friday')"
                        list-value-field="name"
                        v-model="formData.friday"
                        :required="true"
                        :chooseLabel="$t('time')"
                        :error-message="$errorMessage(errors, 'friday')"
                        :list="timeList"
                    />
                </div>
                <div class="col-md-4">
                    <app-form-group
                        type="select"
                        :label="$t('saturday')"
                        list-value-field="name"
                        v-model="formData.saturday"
                        :required="true"
                        :chooseLabel="$t('time')"
                        :error-message="$errorMessage(errors, 'saturday')"
                        :list="timeList"
                    />
                </div>
                <div class="col-md-4">
                    <app-form-group
                        type="select"
                        :label="$t('sunday')"
                        list-value-field="name"
                        v-model="formData.sunday"
                        :required="true"
                        :chooseLabel="$t('time')"
                        :error-message="$errorMessage(errors, 'sunday')"
                        :list="timeList"
                    />
                </div>
                <div class="col-md-12">
                    <app-form-group-selectable
                        type="multi-select"
                        :label="$t('tags')"
                        list-value-field="title"
                        v-model="formData.tags"
                        :chooseLabel="$t('tag')"
                        :error-message="$errorMessage(errors, 'tags')"
                        :fetch-url="`${TENANT_BASE_URL}app/interview-tag?per_page=0&type=0,2`"
                    />
                </div>
                <div class="col-md-12">
                    <app-form-group
                        type="textarea"
                        label-alignment="top"
                        :label="$t('remark')"
                        :placeholder="$textAreaPlaceHolder('remark')"
                        v-model="formData.remark"
                        :error-message="$errorMessage(errors, 'remark')">
                    </app-form-group>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label>{{ $t('attachments') }}</label>
                        <app-input
                            type="dropzone"
                            v-model="files"
                            :error-message="$errorMessage(errors, 'files.0')"
                        />
                    </div>
                </div>

                <div class="col-md-12" v-if="current_files.length">
                    <div class="form-group">
                        <label>{{ $t('current_files') }}</label>
                        <div class="img-container">
                            <div class="img-box" v-for="(url, index) in current_files" :key="'current-image-' + index">
                                <img v-if="isImage(url)"
                                    :src="url"
                                    class="img-thumbnail"
                                    :title="getFileName(url)"
                                />
                                <div v-else
                                    :href="url"
                                    target="_blank"
                                    class="d-flex align-items-center justify-content-center text-truncate img-thumbnail"
                                    :title="getFileName(url)"
                                >
                                    <i :class="`fa fa-file-${getFileExtension(url).substring(1)}`"></i>
                                </div>
                                <div class="img-action">
                                    <button type="button"
                                        class="btn btn-sm btn-primary"
                                        @click="viewFile(url)"
                                        :title="$t('view')">
                                        <i class="fas fa-eye"></i>
                                    </button>
                                    <button type="button"
                                        class="btn btn-sm btn-danger"
                                        @click="deleteFile(index)"
                                        :title="$t('delete')">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";
import {formatDateForServer} from "../../../../../common/Helper/Support/DateTimeHelper";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";

export default {
    name  : "CandidateCreateModal",
    mixins: [FormHelperMixins, ModalMixin],
    props: {
        selectedUrl: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            TENANT_BASE_URL,
            locate       : window?.appLanguage.toLowerCase(),
            files        : [],
            fields       : [],
            timeList     : [],
            formData     : {},
            current_files: [],
            deleted_files: [],
        }
    },
    computed: {
        isEditMode() {
            return !!this.selectedUrl;
        }
    },
    mounted() {
        axiosGet(`${TENANT_BASE_URL}api/candidate/time`).then(({data}) => {
            this.timeList = data
        }).catch((error) => {
            this.$toastr.e(error.response.data.message)
        }).finally(() => {
            this.errors = {};
        })
        axiosGet(`${TENANT_BASE_URL}api/attribute/fields/candidate`).then(({data}) => {
            if (data.length > 0) {
                for (const field of data) {
                    this.formData[field.name] = '';
                }
            }
            this.fields = data
        }).catch((error) => {
            this.$toastr.e(error.response.data.message)
        })
    },
    methods: {
        submitData() {
            this.formData.start = this.formData.start ? formatDateForServer(this.formData.start) : '';

            let url      = this.$refs.form.dataset["url"];
            let formData = formDataAssigner(new FormData, this.formData);

            if (this.formData.tags) {
                this.formData.tags.forEach(tag_id => formData.append('tag_id[]', tag_id));
            }
            if (this.fields.length > 0) {
                for (const field of this.fields) {
                    formData.set(field.name, this.formData[field.name])
                }
            }

            this.files.forEach(file => formData.append('files[]', file));
            this.deleted_files.forEach(fileUrl => formData.append('deleted_files[]', fileUrl))

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }
            this.loading = true;

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#candidate-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'candidate-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader     = false;
            this.current_files = response.data.files || [];

            delete response.data.files;

            this.formData = response.data;

            if (this.fields.length > 0) {
                for (const field of this.fields) {
                    this.formData[field.name] = response.data[field.name];
                }
            }
        },
    },
}
</script>
